import { render, staticRenderFns } from "./BeneficialOwnerRegistryBreakdown.vue?vue&type=template&id=449caf17&scoped=true&"
import script from "./BeneficialOwnerRegistryBreakdown.vue?vue&type=script&lang=js&"
export * from "./BeneficialOwnerRegistryBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449caf17",
  null
  
)

export default component.exports